export default "/images/bd7fd9d197a164fe213c263f905a7342.png";